import errorHandlers from './errorHandlers'

export default {
  datahubUrl: process.env.VUE_APP_DATAHUB_URL,
  authhubUrl: process.env.VUE_APP_AUTHHUB_URL,
  acUrl: process.env.VUE_APP_AC_URL,
  dataCaptureUrl: process.env.VUE_APP_DATACAPTURE_URL,
  axonUrl: process.env.VUE_APP_AXON_URL,
  errorHandlers
}
